import { RouterNetworkWirelessIcon } from './RouterNetworkWirelessIcon';

/**
 * author: Michael Richins
 * id 331F3E71-198F-4A8D-95B2-EA348B4F55C3
 * name router-network-wireless
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/router-network-wireless.svg
 * tags
 * - Device / Tech 
 */
export const WirelessRouterIcon = RouterNetworkWirelessIcon;
export default WirelessRouterIcon